import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/data.service';
import { firstValueFrom } from 'rxjs';

/**
 *  Ki- és beiratkozás záradékkal, egy ablakban.
 *
 *  A záradék itt NEM opcionális: a jogviszony-változás a törzslapon záradékkal jelenik
 *  meg, enélkül hiányos lenne. A szerver is elutasítja a záradék nélküli kérést, ez az
 *  ablak csak előbb szól – és felkínálja a „jogviszony" kategóriájú sablonokat, hogy ne
 *  kelljen kézzel gépelni a szokásos szövegeket.
 */
@Component({
  selector: 'app-jogviszony-modal',
  templateUrl: './jogviszony-modal.component.html',
  styleUrls: ['./jogviszony-modal.component.scss'],
})
export class JogviszonyModalComponent implements OnInit {
  @Input() muvelet: 'kiiratkozas' | 'beiratkozas' = 'kiiratkozas';
  @Input() oktazon = '';
  @Input() tanuloNev = '';
  @Input() intezmenyId = '';
  /** Beiratkozásnál kötelező: melyik osztályba. */
  @Input() osztaly = '';
  @Input() osztalyok: any[] = [];

  datum = new Date().toISOString().slice(0, 10);
  szoveg = '';
  sablonok: any[] = [];
  fut = false;
  /** Kiiratkozásnál: a megszűnés oka kóddal (backend/kilepes-okok.js), kiegészítés, új intézmény. */
  okok: { kod: string; nev: string; jogalap: string }[] = [];
  okKod = '';
  ok = '';
  atvevo = '';

  constructor(private http: HttpClient, private modalCtrl: ModalController, private data: DataService) {}

  /** Iskolaváltás: „Másik iskola átvette” ok vagy megadott új intézmény – az átadó csomag kell. */
  get iskolavaltas(): boolean {
    return this.muvelet === 'kiiratkozas' && (this.okKod === 'atvetel' || !!this.atvevo.trim());
  }

  get cim(): string {
    return this.muvelet === 'kiiratkozas' ? 'Kiiratkozás' : 'Beiratkozás';
  }

  async ngOnInit() {
    try {
      this.sablonok = await firstValueFrom(
        this.http.get<any[]>('/api/zaradek/sablonok/lista?kategoria=jogviszony'));
    } catch { this.sablonok = []; }
    if (this.muvelet === 'kiiratkozas') {
      try { this.okok = await firstValueFrom(this.http.get<any[]>('/api/tanulo-kilepes/okok')) || []; } catch { this.okok = []; }
    }
  }

  sablonValaszt(szoveg: string) {
    // Hozzáfűzzük, nem felülírjuk: több sablon is összeállhat egy záradékká.
    this.szoveg = this.szoveg ? `${this.szoveg.trim()} ${szoveg}` : szoveg;
  }

  async mentes() {
    if (!this.szoveg.trim()) {
      this.data.sendToast('A záradék szövege kötelező – ez kerül a törzslapra.', 'warning');
      return;
    }
    if (this.muvelet === 'beiratkozas' && !this.osztaly) {
      this.data.sendToast('Válaszd ki az osztályt.', 'warning');
      return;
    }

    this.fut = true;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/jogviszony/${this.muvelet}`, {
        intezmeny: this.intezmenyId,
        oktazon: this.oktazon,
        osztaly: this.osztaly || undefined,
        datum: this.datum,
        zaradek: { szoveg: this.szoveg.trim(), kategoria: 'jogviszony' },
        ...(this.muvelet === 'kiiratkozas'
          ? { ok_kod: this.okKod || undefined, ok: this.ok.trim() || undefined, atvevo: this.atvevo.trim() || undefined }
          : {}),
      }));
      this.data.sendToast(this.muvelet === 'kiiratkozas'
        ? `Kiiratkoztatva ${this.datum} nappal, a záradék rögzítve.`
        : `Beiratkoztatva ${this.datum} nappal, a záradék rögzítve.`, 'success');
      //  Iskolaváltás (2026-11-02, Nkt. 41. § (8a)): ha az átadó csomag még nem készült el, szólunk.
      if (r?.iskolavaltas && !r?.atado?.keszult) {
        this.data.sendToast('Iskolaváltás: az átadó csomag (Nkt. 41. § (8a)) még nem készült el – Admin › Iskolaváltás.', 'warning');
      }
      await this.modalCtrl.dismiss({ ok: true, eredmeny: r });
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A művelet nem sikerült.', 'error');
    } finally {
      this.fut = false;
    }
  }

  megse() { this.modalCtrl.dismiss({ ok: false }); }
}
